import React from "react";
import useReveal from "../../hooks/useReveal";

export default function Reveal({
  as: Tag = "div",
  className = "",
  style,
  children,
  ...rest
}) {
  const [ref, visible] = useReveal();
  return (
    <Tag
      ref={ref}
      className={`reveal ${className}`.trim()}
      data-in={visible ? "" : undefined}
      style={style}
      {...rest}
    >
      {children}
    </Tag>
  );
}
